import React, { useState } from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import { listarTodos, QUERY_LISTAR_TODOS_AGENDAMIENTOS_HOTEL } from "../../../services/agendamientosHotelServicios";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { useQuery } from "@tanstack/react-query";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/hotel",
    label: "Reserva Hotel",
  },
  {
    path: "/reservas/hotel/listar",
    label: "Listar",
    isActive: true,
  }
];

function ListaAgendamientosHotel() {
  // Filtros de query, Eg: ?nombreMascota=Draco&nombrePropietario=Pedro
  const [queryParams, setQueryParams] = useState("");

  const {
    data: paginaAgendamientos,
    isLoading,
    isError,
  } = useQuery({
      queryKey: [
        QUERY_LISTAR_TODOS_AGENDAMIENTOS_HOTEL, 
        queryParams
      ],
      queryFn: async () => await listarTodos(queryParams),
    });

  const actualizarFiltroQuery = (filtrosQuery: string) => {
    setQueryParams(filtrosQuery);
  }

  return (
    <>
      <Page
        description="Visualiza y cancela agendamientos de Hotel"
        title="Agendamientos de Hotel"
        breadCrumbs={breadCrumbs}
      >
        <TableSection
          actualizarFiltroQuery={actualizarFiltroQuery}
          isLoading={isLoading} 
          paginaAgendamientos={paginaAgendamientos} />
      </Page>
      {isError && <ServerErrorModal />}
    </>
  );
}

export default ListaAgendamientosHotel;
